import React from "react";
import { Select, MenuItem } from "@material-ui/core";
import { useStyles } from "./styles";

export function SelectStyled(props) {
  const { name, items, handlerOnChange, defaultValue, disabled = false } = props;
  const classes = useStyles();

  return (
    <Select
      className={classes.root}
      value={String(defaultValue)}
      name={name}
      displayEmpty
      autoWidth
      disabled={disabled}
      onChange={handlerOnChange}
      data-testid="btn_select"
      style={{ color: '#444C67' }}
      inputProps={{
        style: { color: '#444C67' }
      }}
    >
      {items &&
        items.map((i, key) => (
          <MenuItem key={key} value={String(i.value)} style={{ color: '#444C67' }}>
            {i.display}
          </MenuItem>
        ))}
    </Select>
  );
}
